import { useCamera } from 'cameras/hooks/useCamera';
import { useStream } from 'streams/hooks/useStream';
import { VideoSource } from 'hooks/api/useDeploymentsVideoSources';
import { VideoSourceSelection } from 'pipelines/services/rete/controls/video_source_selector';

/** @deprecated */
export function useVideoSource(
  videoSource?: VideoSource | VideoSourceSelection | null
) {
  const id =
    videoSource &&
    typeof videoSource === 'object' &&
    ('id' in videoSource
      ? videoSource.id
      : (videoSource as VideoSourceSelection).source_id);

  function isCamera(videoSource?: VideoSource | VideoSourceSelection | null) {
    if (!videoSource || !(typeof videoSource === 'object')) return false;

    if ('source_type' in videoSource) {
      return videoSource.source_type === 'camera';
    }

    return 'conn_type' in videoSource;
  }

  function isStream(videoSource?: VideoSource | VideoSourceSelection | null) {
    if (!videoSource || !(typeof videoSource === 'object')) return false;

    if ('source_type' in videoSource) {
      return videoSource.source_type === 'stream';
    }

    return 'stream_type' in videoSource;
  }

  const cameraQueryResult = useCamera(id || undefined, {
    enabled: isCamera(videoSource),
  });
  const streamQueryResult = useStream(id || undefined, {
    enabled: isStream(videoSource),
  });

  if (isCamera(videoSource)) {
    return cameraQueryResult;
  }

  return streamQueryResult;
}
